import { uniq } from 'lodash'

import type RestDay from 'modules/shift_management/store/internal/models/RestDay'
import type Shift from 'modules/shift_management/store/internal/models/Shift'

const shiftManagementCounts = (shifts: Shift[], restDays: RestDay[]) => {
  const shiftsCount = uniq(shifts).length
  const restDaysCount = restDays.length

  const shiftEmployeeIds = shifts.map((shift) => shift.employeeId)
  const restDayEmployeeIds = restDays.map((shift) => shift.employeeId)
  const employeeIds = uniq([...shiftEmployeeIds, ...restDayEmployeeIds])
  const employeeCount = employeeIds.length

  return { shiftsCount, restDaysCount, employeeCount }
}

export default shiftManagementCounts
